/*
  Shopify size dropdown converter
  Version: 2026-05-06.numeric-knicker-alias-map-v3

  Summary
  - Keeps <option value="..."> untouched, even when the value is blank.
  - Updates only the visible option label.
  - Uses UK sizes as the source size.
  - Converts for UK, USA, EU, FR, IT and AU regions.
  - Treats EU as EU member countries except FR and IT, which use their own columns.
  - Handles Shopify localization objects, direct country codes, or direct region strings.
  - Handles status text after a spaced hyphen, e.g. "8 - only 1 left!".
  - Handles combined bra cups, e.g. "30J/JJ" and "32K/KK".
  - Handles combined knicker sizes, e.g. "S/M", "L/XL", "8/10".
  - Handles numerical standard knicker aliases, e.g. "8", "10", "12".
  - Handles numerical CK grouped aliases, e.g. "8/10", "12/14".
  - Handles individual numbers inside CK grouped rows, e.g. "8" -> first half of "8/10".
  - Uses CK knicker sizing for Scantilly, Curvy Kate, Flirtelle, Adella and Liaison.
  - Uses standard knicker sizing for every other vendor, including missing vendors.

  Typical Shopify usage
    updateDropdownSizes(document.querySelector('select[name="options[Size]"]'), {
      localization: { country: { iso_code: {{ localization.country.iso_code | json }} } },
      vendor: {{ product.vendor | json }},
      sizeType: 'auto',
      convertedSizeColumn: 13,
      minimumGap: 2
    });
*/
(function () {
  'use strict';

  var VERSION = '2026-05-06.numeric-knicker-alias-map-v3';

  var BRA_BACK_SIZES = {
  "28": {
    "UK": "28",
    "USA": "28",
    "EU": "60",
    "FR": "75",
    "IT": "0",
    "AU": "6"
  },
  "30": {
    "UK": "30",
    "USA": "30",
    "EU": "65",
    "FR": "80",
    "IT": "0",
    "AU": "8"
  },
  "32": {
    "UK": "32",
    "USA": "32",
    "EU": "70",
    "FR": "85",
    "IT": "1",
    "AU": "10"
  },
  "34": {
    "UK": "34",
    "USA": "34",
    "EU": "75",
    "FR": "90",
    "IT": "2",
    "AU": "12"
  },
  "36": {
    "UK": "36",
    "USA": "36",
    "EU": "80",
    "FR": "95",
    "IT": "3",
    "AU": "14"
  },
  "38": {
    "UK": "38",
    "USA": "38",
    "EU": "85",
    "FR": "100",
    "IT": "4",
    "AU": "16"
  },
  "40": {
    "UK": "40",
    "USA": "40",
    "EU": "90",
    "FR": "105",
    "IT": "5",
    "AU": "18"
  },
  "42": {
    "UK": "42",
    "USA": "42",
    "EU": "95",
    "FR": "110",
    "IT": "6",
    "AU": "20"
  },
  "44": {
    "UK": "44",
    "USA": "44",
    "EU": "100",
    "FR": "115",
    "IT": "7",
    "AU": "22"
  },
  "46": {
    "UK": "46",
    "USA": "46",
    "EU": "105",
    "FR": "120",
    "IT": "8",
    "AU": "24"
  },
  "48": {
    "UK": "48",
    "USA": "48",
    "EU": "110",
    "FR": "125",
    "IT": "9",
    "AU": "26"
  }
};

  var BRA_CUP_SIZES = {
  "D": {
    "UK": "D",
    "USA": "D",
    "EU": "D",
    "FR": "D",
    "IT": "D",
    "AU": "D"
  },
  "DD": {
    "UK": "DD",
    "USA": "DD/E",
    "EU": "E",
    "FR": "E",
    "IT": "DD",
    "AU": "DD"
  },
  "E": {
    "UK": "E",
    "USA": "DDD/F",
    "EU": "F",
    "FR": "F",
    "IT": "E",
    "AU": "E"
  },
  "F": {
    "UK": "F",
    "USA": "G",
    "EU": "G",
    "FR": "G",
    "IT": "F",
    "AU": "F"
  },
  "FF": {
    "UK": "FF",
    "USA": "H",
    "EU": "H",
    "FR": "H",
    "IT": "FF",
    "AU": "FF"
  },
  "G": {
    "UK": "G",
    "USA": "I",
    "EU": "I",
    "FR": "I",
    "IT": "G",
    "AU": "G"
  },
  "GG": {
    "UK": "GG",
    "USA": "J",
    "EU": "J",
    "FR": "J",
    "IT": "GG",
    "AU": "GG"
  },
  "H": {
    "UK": "H",
    "USA": "K",
    "EU": "K",
    "FR": "K",
    "IT": "H",
    "AU": "H"
  },
  "HH": {
    "UK": "HH",
    "USA": "L",
    "EU": "L",
    "FR": "L",
    "IT": "HH",
    "AU": "HH"
  },
  "J": {
    "UK": "J",
    "USA": "M",
    "EU": "M",
    "FR": "M",
    "IT": "J",
    "AU": "J"
  },
  "JJ": {
    "UK": "JJ",
    "USA": "N",
    "EU": "N",
    "FR": "N",
    "IT": "JJ",
    "AU": "JJ"
  },
  "K": {
    "UK": "K",
    "USA": "O",
    "EU": "O",
    "FR": "O",
    "IT": "K",
    "AU": "K"
  }
};

  // Optional extension for product sizes present in store data but not supplied in the cup CSV.
  // Pass allowInferredCupSizes: false to avoid using these inferred rows.
  var INFERRED_BRA_CUP_SIZES = {
    "KK": {
      "UK": "KK",
      "USA": "P",
      "EU": "P",
      "FR": "P",
      "IT": "KK",
      "AU": "KK"
    }
  };

  var STANDARD_KNICKERS = [
  {
    "SIZE": "XS",
    "UK": "8",
    "USA": "4",
    "EU": "34",
    "FR": "8",
    "IT": "8",
    "AU": "8"
  },
  {
    "SIZE": "S",
    "UK": "10",
    "USA": "6",
    "EU": "36",
    "FR": "10",
    "IT": "10",
    "AU": "10"
  },
  {
    "SIZE": "M",
    "UK": "12",
    "USA": "8",
    "EU": "38",
    "FR": "12",
    "IT": "12",
    "AU": "12"
  },
  {
    "SIZE": "L",
    "UK": "14",
    "USA": "10",
    "EU": "40",
    "FR": "14",
    "IT": "14",
    "AU": "14"
  },
  {
    "SIZE": "XL",
    "UK": "16",
    "USA": "12",
    "EU": "42",
    "FR": "16",
    "IT": "16",
    "AU": "16"
  },
  {
    "SIZE": "2XL",
    "UK": "18",
    "USA": "14",
    "EU": "44",
    "FR": "18",
    "IT": "18",
    "AU": "18"
  },
  {
    "SIZE": "3XL",
    "UK": "20",
    "USA": "16",
    "EU": "46",
    "FR": "20",
    "IT": "20",
    "AU": "20"
  },
  {
    "SIZE": "4XL",
    "UK": "22",
    "USA": "18",
    "EU": "48",
    "FR": "22",
    "IT": "22",
    "AU": "22"
  },
  {
    "SIZE": "5XL",
    "UK": "24",
    "USA": "20",
    "EU": "50",
    "FR": "24",
    "IT": "24",
    "AU": "24"
  },
  {
    "SIZE": "6XL",
    "UK": "26",
    "USA": "22",
    "EU": "52",
    "FR": "26",
    "IT": "26",
    "AU": "26"
  },
  {
    "SIZE": "7XL",
    "UK": "28",
    "USA": "24",
    "EU": "54",
    "FR": "28",
    "IT": "28",
    "AU": "28"
  }
];

  var CK_KNICKERS = [
  {
    "SIZE": "S",
    "UK": "8/10",
    "USA": "4/6",
    "EU": "34/36",
    "FR": "36/38",
    "IT": "36/38",
    "AU": "8/10"
  },
  {
    "SIZE": "M",
    "UK": "12/14",
    "USA": "8/10",
    "EU": "38/40",
    "FR": "40/42",
    "IT": "40/42",
    "AU": "12/14"
  },
  {
    "SIZE": "L",
    "UK": "16/18",
    "USA": "12/14",
    "EU": "42/44",
    "FR": "44/46",
    "IT": "44/46",
    "AU": "16/18"
  },
  {
    "SIZE": "XL",
    "UK": "20/22",
    "USA": "16/18",
    "EU": "46/48",
    "FR": "48/50",
    "IT": "48/50",
    "AU": "20/22"
  },
  {
    "SIZE": "2XL",
    "UK": "24/26",
    "USA": "20/22",
    "EU": "50/52",
    "FR": "52/54",
    "IT": "52/54",
    "AU": "24/26"
  },
  {
    "SIZE": "3XL",
    "UK": "28/30",
    "USA": "24/26",
    "EU": "54/56",
    "FR": "56/58",
    "IT": "56/58",
    "AU": "28/30"
  }
];

  var SUPPORTED_REGIONS = {
    UK: true,
    USA: true,
    EU: true,
    FR: true,
    IT: true,
    AU: true
  };

  // EU member country ISO codes, excluding France (FR) and Italy (IT), which have own columns.
  var EU_COUNTRIES_EX_FR_IT = {
    AT: true,
    BE: true,
    BG: true,
    HR: true,
    CY: true,
    CZ: true,
    DK: true,
    EE: true,
    FI: true,
    DE: true,
    GR: true,
    HU: true,
    IE: true,
    LV: true,
    LT: true,
    LU: true,
    MT: true,
    NL: true,
    PL: true,
    PT: true,
    RO: true,
    SK: true,
    SI: true,
    ES: true,
    SE: true
  };

  var CK_VENDOR_LOOKUP = {
    'SCANTILLY': true,
    'CURVY KATE': true,
    'FLIRTELLE': true,
    'ADELLA': true,
    'LIAISON': true
  };

  function normaliseText(value) {
    return String(value == null ? '' : value).replace(/\u00a0/g, ' ').trim();
  }

  function upper(value) {
    return normaliseText(value).toUpperCase();
  }

  function hasOwn(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  function getCountryCode(localizationOrCode) {
    var country;

    if (!localizationOrCode) {
      return '';
    }

    if (typeof localizationOrCode === 'string') {
      return upper(localizationOrCode);
    }

    country = localizationOrCode.country ||
      localizationOrCode.current_country ||
      localizationOrCode.currentCountry;

    if (typeof country === 'string') {
      return upper(country);
    }

    if (country && typeof country === 'object') {
      return upper(
        country.iso_code ||
        country.isoCode ||
        country.code ||
        country.country_code ||
        country.countryCode
      );
    }

    return upper(
      localizationOrCode.iso_code ||
      localizationOrCode.isoCode ||
      localizationOrCode.country_code ||
      localizationOrCode.countryCode ||
      localizationOrCode.region
    );
  }

  function getRegion(localizationOrCode) {
    var code = getCountryCode(localizationOrCode);

    if (code === 'GB' || code === 'UK') {
      return 'UK';
    }

    if (code === 'US' || code === 'USA') {
      return 'USA';
    }

    if (code === 'FR') {
      return 'FR';
    }

    if (code === 'IT') {
      return 'IT';
    }

    if (code === 'AU' || code === 'AUS') {
      return 'AU';
    }

    if (EU_COUNTRIES_EX_FR_IT[code]) {
      return 'EU';
    }

    // Allows callers to pass a region directly: { region: 'EU' }, 'USA', etc.
    if (SUPPORTED_REGIONS[code]) {
      return code;
    }

    return '';
  }

  function usesCkKnickers(vendor) {
    return !!CK_VENDOR_LOOKUP[upper(vendor)];
  }

  function stripExistingConversionFromSizeText(sizeText) {
    return normaliseText(sizeText).replace(/\s+\((UK|USA|EU|FR|IT|AU)\s+[^)]*\)$/i, '').trim();
  }

  function splitSizeAndTrailingText(label) {
    var cleaned = normaliseText(label);
    var splitAt = cleaned.indexOf(' - ');
    var sizeText;
    var trailingText;

    if (splitAt === -1) {
      sizeText = cleaned;
      trailingText = '';
    } else {
      sizeText = cleaned.slice(0, splitAt);
      trailingText = cleaned.slice(splitAt);
    }

    return {
      sizeText: stripExistingConversionFromSizeText(sizeText),
      trailingText: trailingText
    };
  }

  function restoreOriginalLabel(label) {
    var parsed = splitSizeAndTrailingText(label);
    return parsed.sizeText + parsed.trailingText;
  }

  function getCurrentOptionLabel(option) {
    if (!option) {
      return '';
    }

    if (typeof option.textContent === 'string') {
      return option.textContent;
    }

    if (typeof option.text === 'string') {
      return option.text;
    }

    if (typeof option.label === 'string') {
      return option.label;
    }

    return '';
  }

  function getOriginalLabel(option) {
    var currentLabel = getCurrentOptionLabel(option);
    var restoredLabel = restoreOriginalLabel(currentLabel);

    // Store the currently restored original as a helpful debug marker, but do not rely
    // on old stored labels. That way dynamic stock text can still update correctly.
    if (option && option.setAttribute && restoredLabel) {
      option.setAttribute('data-original-size-label', restoredLabel);
    }

    return restoredLabel;
  }

  function setOptionLabel(option, label) {
    if ('textContent' in option) {
      option.textContent = label;
    } else {
      option.text = label;
    }

    // If the option has an explicit label attribute, keep it in sync too.
    if (option.hasAttribute && option.hasAttribute('label')) {
      option.label = label;
    }
  }

  function braLookupKey(label) {
    return upper(label).replace(/[\s-]/g, '');
  }

  function getCupRow(ukCup, opts) {
    var key = upper(ukCup);

    if (BRA_CUP_SIZES[key]) {
      return BRA_CUP_SIZES[key];
    }

    if (opts.allowInferredCupSizes !== false && INFERRED_BRA_CUP_SIZES[key]) {
      return INFERRED_BRA_CUP_SIZES[key];
    }

    return null;
  }

  function convertBraSize(sizeText, region, opts) {
    var key;
    var match;
    var ukBand;
    var ukCupText;
    var ukCupParts;
    var bandRow;
    var convertedBand;
    var convertedCupParts;
    var i;

    // UK bra sizes are the source sizes, so no bra conversion is needed for UK customers.
    if (region === 'UK') {
      return null;
    }

    key = braLookupKey(sizeText);
    match = key.match(/^(\d{2})([A-Z]+(?:\/[A-Z]+)*)$/);

    if (!match) {
      return null;
    }

    ukBand = match[1];
    ukCupText = match[2];
    ukCupParts = ukCupText.split('/');
    bandRow = BRA_BACK_SIZES[ukBand];

    if (!bandRow) {
      return null;
    }

    convertedBand = normaliseText(bandRow[region]);

    if (!convertedBand || convertedBand === '-') {
      return null;
    }

    convertedCupParts = [];

    for (i = 0; i < ukCupParts.length; i += 1) {
      var cupRow = getCupRow(ukCupParts[i], opts);
      var convertedCup;

      if (!cupRow) {
        return null;
      }

      convertedCup = normaliseText(cupRow[region]);

      if (!convertedCup || convertedCup === '-') {
        return null;
      }

      convertedCupParts.push(convertedCup);
    }

    return convertedBand + convertedCupParts.join('/');
  }

  function knickerLookupKey(value) {
    var key = upper(value).replace(/\s*\/\s*/g, '/').replace(/\s+/g, '');

    // Tolerate labels such as "UK 8", "UK Size 8", "Size 8" or "8 UK".
    key = key.replace(/^(?:UKSIZE|UK|SIZE)(?=[A-Z0-9])/, '');
    key = key.replace(/(?:UKSIZE|UK)$/g, '');

    return key;
  }

  function addAlias(aliasMap, alias, row) {
    var key = knickerLookupKey(alias);

    if (!key) {
      return;
    }

    if (!aliasMap[key]) {
      aliasMap[key] = row;
    }
  }

  function addRangePartAliases(aliasMap, value, row) {
    var parts;
    var i;

    if (normaliseText(value).indexOf('/') === -1) {
      return;
    }

    parts = normaliseText(value).split('/');

    for (i = 0; i < parts.length; i += 1) {
      addAlias(aliasMap, parts[i], row);
    }
  }

  function buildKnickerAliasMap(rows, includeIndividualRangeParts) {
    var aliasMap = {};
    var i;

    for (i = 0; i < rows.length; i += 1) {
      var row = rows[i];

      addAlias(aliasMap, row.SIZE, row);
      addAlias(aliasMap, row.UK, row);

      // CK data is range based, e.g. S = UK 8/10. Including the individual
      // parts means a CK option labelled just "8" can still map to the S row.
      if (includeIndividualRangeParts) {
        addRangePartAliases(aliasMap, row.UK, row);
      }
    }

    return aliasMap;
  }

  var STANDARD_KNICKER_ALIAS_MAP = buildKnickerAliasMap(STANDARD_KNICKERS, false);
  var CK_KNICKER_ALIAS_MAP = buildKnickerAliasMap(CK_KNICKERS, true);

  function getKnickerTables(vendor) {
    if (usesCkKnickers(vendor)) {
      return {
        name: 'ck-knickers',
        rows: CK_KNICKERS,
        aliases: CK_KNICKER_ALIAS_MAP
      };
    }

    return {
      name: 'standard-knickers',
      rows: STANDARD_KNICKERS,
      aliases: STANDARD_KNICKER_ALIAS_MAP
    };
  }

  function getKnickerRow(sizePart, tables) {
    return tables.aliases[knickerLookupKey(sizePart)] || null;
  }

  function getConvertedKnickerValue(row, region) {
    var converted;

    if (!row || !hasOwn(row, region)) {
      return null;
    }

    converted = normaliseText(row[region]);

    if (!converted || converted === '-') {
      return null;
    }

    return converted;
  }

  function splitCombinedSizeText(sizeText) {
    var rawParts = normaliseText(sizeText).split('/');
    var parts = [];
    var i;

    for (i = 0; i < rawParts.length; i += 1) {
      var part = normaliseText(rawParts[i]);

      if (part) {
        parts.push(part);
      }
    }

    return parts;
  }

  function joinConvertedKnickerParts(parts) {
    var i;

    for (i = 0; i < parts.length; i += 1) {
      if (normaliseText(parts[i]).indexOf('/') !== -1) {
        return parts.join(' / ');
      }
    }

    return parts.join('/');
  }

  function getConvertedKnickerRangePart(sizePart, rows, region) {
    var key = knickerLookupKey(sizePart);
    var i;

    if (!key) {
      return null;
    }

    for (i = 0; i < rows.length; i += 1) {
      var ukParts = splitCombinedSizeText(rows[i].UK);
      var converted = getConvertedKnickerValue(rows[i], region);
      var convertedParts = splitCombinedSizeText(converted);
      var j;

      if (ukParts.length < 2 || ukParts.length !== convertedParts.length) {
        continue;
      }

      for (j = 0; j < ukParts.length; j += 1) {
        if (knickerLookupKey(ukParts[j]) === key) {
          return convertedParts[j];
        }
      }
    }

    return null;
  }

  function convertKnickerSize(sizeText, region, vendor) {
    var tables = getKnickerTables(vendor);
    var exactRow = getKnickerRow(sizeText, tables);
    var exactConverted = getConvertedKnickerValue(exactRow, region);
    var rangePartConverted = getConvertedKnickerRangePart(sizeText, tables.rows, region);
    var parts;
    var convertedParts;
    var i;

    // For CK-style vendors, rows can be grouped, e.g. UK 8/10 -> FR 36/38.
    // If the product option is a single number, convert the matching part: 8 -> 36, 10 -> 38.
    if (rangePartConverted && normaliseText(sizeText).indexOf('/') === -1) {
      return {
        convertedSize: rangePartConverted,
        tableName: tables.name,
        matchMode: 'range-part'
      };
    }

    // Then try exact aliases, e.g.:
    // - Standard: "XS" or "8"
    // - CK: "S" or "8/10"
    if (exactConverted) {
      return {
        convertedSize: exactConverted,
        tableName: tables.name,
        matchMode: 'exact-or-alias'
      };
    }

    // Then try combined entries, e.g.:
    // - Standard: "S/M", "8/10", "10/12"
    // - CK: "S/M", "L/XL"
    if (normaliseText(sizeText).indexOf('/') === -1) {
      return null;
    }

    parts = splitCombinedSizeText(sizeText);

    if (parts.length < 2) {
      return null;
    }

    convertedParts = [];

    for (i = 0; i < parts.length; i += 1) {
      var partRow = getKnickerRow(parts[i], tables);
      var partConverted = getConvertedKnickerValue(partRow, region);

      if (!partConverted) {
        return null;
      }

      convertedParts.push(partConverted);
    }

    return {
      convertedSize: joinConvertedKnickerParts(convertedParts),
      tableName: tables.name,
      matchMode: 'combined-parts'
    };
  }

  function comparableSize(value) {
    return upper(value).replace(/\u00a0/g, ' ').replace(/\s+/g, '');
  }

  function repeatString(value, count) {
    var output = '';
    var i;

    for (i = 0; i < count; i += 1) {
      output += value;
    }

    return output;
  }

  function getLabelPadding(sizeText, opts) {
    var column = parseInt(opts.convertedSizeColumn == null ? opts.alignColumn : opts.convertedSizeColumn, 10);
    var minimumGap = parseInt(opts.minimumGap == null ? 2 : opts.minimumGap, 10);
    var padChar = opts.paddingCharacter == null ? '\u00a0' : String(opts.paddingCharacter);
    var baseLength = normaliseText(sizeText).length;
    var padLength;

    // Backward-compatible escape hatch: pass a fixed spacing string if preferred.
    if (opts.spaceBeforeBracket != null) {
      return String(opts.spaceBeforeBracket);
    }

    if (!column || column < 1) {
      column = 13;
    }

    if (!minimumGap || minimumGap < 1) {
      minimumGap = 2;
    }

    if (!padChar) {
      padChar = ' ';
    }

    padLength = Math.max(minimumGap, column - baseLength);

    return repeatString(padChar, padLength);
  }

  function formatConvertedLabel(sizeText, region, convertedSize, opts) {
    return sizeText + getLabelPadding(sizeText, opts) + '(' + region + ' ' + convertedSize + ')';
  }

  function resolveTarget(targetElm) {
    if (typeof targetElm === 'string') {
      return document.querySelector(targetElm);
    }

    return targetElm;
  }

  function normaliseSizeType(sizeType) {
    var value = upper(sizeType || 'auto');

    if (value === 'PANTIES' || value === 'BRIEFS' || value === 'KNICKER') {
      return 'KNICKERS';
    }

    if (value === 'BRA' || value === 'BRAS') {
      return 'BRA';
    }

    if (value === 'AUTO') {
      return 'AUTO';
    }

    return value;
  }

  function shouldAppendConvertedSize(sizeText, convertedSize, region, matchedType, opts) {
    var sameSize = comparableSize(sizeText) === comparableSize(convertedSize);
    var appendSameSizeForKnickers;

    if (!sameSize) {
      return true;
    }

    if (opts.appendSameSize) {
      return true;
    }

    if (matchedType === 'knickers') {
      if (opts.appendSameSizeForKnickers != null) {
        return !!opts.appendSameSizeForKnickers;
      }

      // For non-UK stores, show "8 (FR 8)" / "8 (AU 8)" so numeric briefs
      // visibly show that the matching worked even when the number is identical.
      return region !== 'UK';
    }

    return false;
  }

  function getRequestedRegion(opts) {
    if (opts.region) {
      return getRegion(opts.region);
    }

    return getRegion(opts.localization || opts.country || opts.countryCode);
  }

  function convertSizeLabel(label, config) {
    var opts = config || {};
    var region = getRequestedRegion(opts);
    var sizeType = normaliseSizeType(opts.sizeType || 'auto');
    var vendor = opts.vendor || '';
    var originalLabel = restoreOriginalLabel(label);
    var parsed = splitSizeAndTrailingText(originalLabel);
    var sizeText = parsed.sizeText;
    var trailingText = parsed.trailingText;
    var convertedSize = null;
    var matchedType = '';
    var knickerResult = null;
    var newLabel;

    if (!SUPPORTED_REGIONS[region]) {
      return {
        ok: false,
        reason: 'Unsupported region or country.',
        region: region || '',
        originalLabel: originalLabel,
        label: originalLabel
      };
    }

    if (!sizeText) {
      return {
        ok: false,
        reason: 'Empty size label.',
        region: region,
        originalLabel: originalLabel,
        label: originalLabel
      };
    }

    if (sizeType !== 'KNICKERS') {
      convertedSize = convertBraSize(sizeText, region, opts);

      if (convertedSize) {
        matchedType = 'bra';
      }
    }

    if (!convertedSize && sizeType !== 'BRA') {
      knickerResult = convertKnickerSize(sizeText, region, vendor);

      if (knickerResult && knickerResult.convertedSize) {
        convertedSize = knickerResult.convertedSize;
        matchedType = 'knickers';
      }
    }

    if (convertedSize && shouldAppendConvertedSize(sizeText, convertedSize, region, matchedType, opts)) {
      newLabel = formatConvertedLabel(sizeText, region, convertedSize, opts) + trailingText;
    } else {
      newLabel = sizeText + trailingText;
    }

    return {
      ok: true,
      region: region,
      originalLabel: originalLabel,
      sizeText: sizeText,
      trailingText: trailingText,
      label: newLabel,
      convertedSize: convertedSize || '',
      matchedType: matchedType,
      tableName: knickerResult ? knickerResult.tableName : '',
      matchMode: knickerResult ? knickerResult.matchMode : '',
      changed: newLabel !== originalLabel
    };
  }

  /**
   * Convert a Shopify size dropdown option label to include regional size guidance.
   *
   * @param {HTMLSelectElement|string} targetElm select element or selector.
   * @param {Object} config
   * @param {Object|string} config.localization Shopify localization object, country code, or region.
   * @param {string} config.vendor Product vendor. Used to choose CK knicker conversion table.
   * @param {'auto'|'bra'|'knickers'} config.sizeType Defaults to auto.
   * @param {boolean} config.appendSameSize Set true to show labels like "32D (USA 32D)".
   * @param {boolean} config.appendSameSizeForKnickers Defaults to true outside UK and false in UK.
   * @param {number} config.convertedSizeColumn Column to align the conversion bracket. Defaults to 13.
   * @param {number} config.minimumGap Minimum spaces before the bracket. Defaults to 2.
   * @param {string} config.paddingCharacter Defaults to a non-breaking space.
   * @param {boolean} config.allowInferredCupSizes Defaults to true. Set false to disable KK fallback.
   * @returns {Object} Useful debug details.
   */
  function updateDropdownSizes(targetElm, config) {
    var select = resolveTarget(targetElm);
    var opts = config || {};
    var region = getRequestedRegion(opts);
    var convertedCount = 0;
    var skippedCount = 0;
    var details = [];
    var i;

    if (!select || !select.options) {
      return {
        ok: false,
        reason: 'Target is not a select element.',
        region: region || '',
        version: VERSION
      };
    }

    if (!SUPPORTED_REGIONS[region]) {
      return {
        ok: false,
        reason: 'Unsupported region or country.',
        region: region || '',
        version: VERSION
      };
    }

    for (i = 0; i < select.options.length; i += 1) {
      var option = select.options[i];
      var originalLabel = getOriginalLabel(option);
      var result;

      if (!originalLabel || option.disabled) {
        skippedCount += 1;
        setOptionLabel(option, originalLabel);
        details.push({
          optionIndex: i,
          originalLabel: originalLabel,
          skipped: true,
          reason: !originalLabel ? 'empty label' : 'disabled option'
        });
        continue;
      }

      result = convertSizeLabel(originalLabel, opts);

      if (result.convertedSize && result.changed) {
        convertedCount += 1;
      } else {
        skippedCount += 1;
      }

      setOptionLabel(option, result.label);

      if (option.setAttribute) {
        option.setAttribute('data-size-converter-version', VERSION);
        option.setAttribute('data-size-region', region);
        option.setAttribute('data-size-source-text', result.sizeText || '');
        option.setAttribute('data-size-trailing-text', result.trailingText || '');
        option.setAttribute('data-size-converted-value', result.convertedSize || '');
        option.setAttribute('data-size-conversion-type', result.matchedType || '');
        option.setAttribute('data-size-conversion-table', result.tableName || '');
        option.setAttribute('data-size-match-mode', result.matchMode || '');
      }

      details.push(result);
    }

    return {
      ok: true,
      version: VERSION,
      region: region,
      converted: convertedCount,
      skipped: skippedCount,
      knickerTable: usesCkKnickers(opts.vendor || '') ? 'ck-knickers' : 'standard-knickers',
      details: details
    };
  }

  // Browser global exports for Shopify theme snippets.
  window.updateDropdownSizes = updateDropdownSizes;

  // Backward-compatible alias matching the example name from the brief.
  window.updatedropdownus = updateDropdownSizes;

  // Small public debug helper. Useful in DevTools:
  // ShopifySizeConverter.convertSizeLabel('8 - only 1 left!', { region: 'FR', sizeType: 'knickers' })
  window.ShopifySizeConverter = {
    version: VERSION,
    updateDropdownSizes: updateDropdownSizes,
    updatedropdownus: updateDropdownSizes,
    convertSizeLabel: convertSizeLabel,
    getRegion: getRegion,
    usesCkKnickers: usesCkKnickers
  };
}());
